module.exports = __webpack_public_path__ + "static/img/icon slt img (2).8d20b11a.svg";